import React from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './pending-order-confirm-action-popup.scss';
class PendingOrderConfirmActionPopup extends React.Component {
  renderContent() {
    const {
      onCancel,
      loading,
      onActionConfirm,
      action,
      orderId
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
      className: classes.title
    }, "Are you sure you want to ", action, " this order?"), /*#__PURE__*/React.createElement("div", {
      className: classes.actions
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Cancel",
      type: "grey",
      onClick: onCancel,
      dataButton: "Cancel",
      className: classes.button
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      size: "small",
      disabled: loading,
      onClick: () => {
        if (loading) {
          return null;
        }
        onActionConfirm({
          id: orderId,
          action
        });
      },
      dataButton: "Yes",
      className: classes.button
    }, "Yes")));
  }
  render() {
    const {
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(ControlDialog, {
      open: true,
      onRequestClose: onClose,
      content: this.renderContent()
      // @todo. auto generated. fix this error
      // @ts-ignore
      ,
      dataPopup: "PendingOrderActionPopup"
    });
  }
}
export default PendingOrderConfirmActionPopup;